import { ApiHandler, createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { getPartCollection, GetPartCollectionApiParameter } from "@store/Services/PartsService";
import { StoreHandlerProps } from "@store/Store/HandlerCreator";
import { PartCollectionModel, PartModel } from "@store/Types/Parts";

type Parameter = GetPartCollectionApiParameter & HasOnSuccess<PartModel[]>;
type Props = StoreHandlerProps;

type HandlerType = ApiHandler<Parameter, PartCollectionModel, Props>;

export const PopulateApiParameter: HandlerType = props => {
    const { onSuccess, ...parameter } = props.parameter;
    props.apiParameter = { ...parameter };
};

export const DispatchBeginLoadParts: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/Parts/BeginLoadParts",
        parameter: props.apiParameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getPartCollection(props.apiParameter);
};

export const DispatchCompleteLoadParts: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/Parts/CompleteLoadParts",
        collection: props.apiResult,
        parameter: props.apiParameter,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult.parts);
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadParts,
    RequestDataFromApi,
    DispatchCompleteLoadParts,
    ExecuteOnSuccessCallback,
];

const loadParts = createHandlerChainRunner(chain, "LoadParts");
export default loadParts;
